import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

// TODO: deprecated
// Use `rtg-field-description` in place of `sb-hint`

@customElement("sb-hint")
export class SbHint extends LitElement {
  // Use light DOM
  createRenderRoot() {
    return this;
  }

  @property({ type: String }) content = "";

  render() {
    return html`<p class="sb-mt-2">${this.content}</p>`;
  }
}
